module.exports = __webpack_public_path__ + "img/CLP.cf8eaa41.svg";